import * as _ from 'underscore';
export default class Calendar {
    constructor() {
        console.log('%c👍🏼 Calendar', 'color: yellow');
        
        this.calendar = document.querySelector('.calendar-module')
        this.calendarList = this.calendar.querySelector('.calendar-list')
        this.calendarListResults = this.calendar.querySelector('.calendar-list__results')
        this.calendarMap = this.calendar.querySelector('.calendar-map')
        this.timeframe = 'All';
        this.tags = []
        this.search = ""
        this.eventTemplate = this.calendar.querySelector('.eventTemplate');
        this.map = null;
        this.markerArray = [];
        this.eventData;
        this.overlay = this.calendar.querySelector('.overlay');
        this.noResults = this.calendar.querySelector('.calendar-list__noresults');
        this.allButton = this.calendar.querySelector('.calendar-map__sidebar-filter-button-all')
        this.pastCalendar = Number(this.calendar.getAttribute('data-past'));

    }
    init() {

        if(this.pastCalendar){
            console.log('past calendar');
        } else {
            console.log('future calendar');
        }

        const self = this;
        const calendarToggle = this.calendar.querySelector('.form-check-input');
        
        calendarToggle.addEventListener('click', event => {
            if(calendarToggle.checked) {
                this.calendarList.style.display = 'none';
                this.calendarMap.style.display = 'flex';
            } else {
                this.calendarList.style.display = 'flex';
                this.calendarMap.style.display = 'none';
            }
        })

        this.addLoadMoreListeners()
        this.loadMap();
        const whenSelect = this.calendar.querySelector('select');    
        const whenFilterButtons = this.calendar.querySelectorAll('.calendar-map__filter-button');
        whenFilterButtons.forEach(button => {
            button.addEventListener( 'click', async event => {
              
                whenFilterButtons.forEach(btn => btn.classList.remove('calendar-map__filter-button--active'));
                whenSelect.classList.remove('monthSelect--active');
                button.classList.add('calendar-map__filter-button--active');
               
                this.timeframe = event.target.value;
                this.showOverlay();
                await this.loadEvents();
                this.hideOverlay();
                this.filterEvents();
                this.updateMap();
            })
        })
        if(whenSelect) {
            whenSelect.addEventListener( 'change', async event => {
                whenFilterButtons.forEach(btn => btn.classList.remove('calendar-map__filter-button--active'));
                whenSelect.classList.add('monthSelect--active');
                this.timeframe = event.target.value;
                this.showOverlay();
                await this.loadEvents();
                this.hideOverlay();
                this.filterEvents();
                this.updateMap();
            })
        }

        const tagFilterButtons = this.calendar.querySelectorAll('.calendar-map__sidebar-filter-button');
        tagFilterButtons.forEach(button => {
            button.addEventListener( 'click', async event => {
                this.allButton.classList.remove('calendar-map__sidebar-filter-button-all--active');
                button.classList.toggle('calendar-map__sidebar-filter-button--active');
                
                const index = self.tags.indexOf(button.dataset.filter);
                if (index === -1) {
                    self.tags.push(button.dataset.filter);
                } else {
                    self.tags.splice(index, 1);
                }
                if(self.tags.length === 0) {
                    this.allButton.classList.add('calendar-map__sidebar-filter-button-all--active');
                }

                this.showOverlay();
                await this.loadEvents();
                this.hideOverlay();
                this.filterEvents();
                this.updateMap();
            })
        })

        this.allButton.addEventListener( 'click', async event => {
           
            this.allButton.classList.add('calendar-map__sidebar-filter-button-all--active');

            tagFilterButtons.forEach(button => {
                button.classList.remove('calendar-map__sidebar-filter-button--active');
            })
            
            self.tags = [];
            this.showOverlay();
            await this.loadEvents();
            this.hideOverlay();
            this.filterEvents();
            this.updateMap();
        })

        const inputElement = document.getElementById('searchInput');
        inputElement.addEventListener('keydown', this.debounce( async (event) => {
            this.search = event.target.value;
            this.showOverlay();
            await this.loadEvents();
            this.hideOverlay();
                this.filterEvents();
                this.updateMap();
        }, 1400)); 

        inputElement.addEventListener( 'search', async event => {
            this.search = event.target.value;
            this.showOverlay();
            await this.loadEvents();
            this.hideOverlay();
            this.filterEvents();
            this.updateMap();
        })
    }

    addLoadMoreListeners () {
        const loadMores = this.calendar.querySelectorAll('.calendar-list__card__load-more');
        loadMores.forEach(expandButton => {
            const blurb = expandButton.previousElementSibling;
            
            expandButton.addEventListener('click', event => {
                event.preventDefault();
                if(expandButton.getAttribute('aria-expanded') === 'false') {
                    expandButton.setAttribute('aria-expanded', 'true');
                    blurb.style.maxHeight = blurb.scrollHeight + "px";
                    expandButton.textContent = 'Show less';
                    expandButton.style.color = "#fe5000";
                }
                else {
                    expandButton.setAttribute('aria-expanded', 'false');
                    blurb.style.maxHeight = "20px";
                    expandButton.textContent = 'Load more';
                    expandButton.style.color = "#00af9b"; 
                }
            })
        }) 
    }

    showOverlay() {
        this.overlay.style.display= 'flex';
    }

    hideOverlay() {
        this.overlay.style.display= 'none';
    }

    async loadEvents() {
        const apiString = this.getAPIString();
        const dataResponse = await fetch(apiString);
        this.eventData = await dataResponse.json();
    }


    async filterEvents() {

        this.noResults.style.display= 'none';
        this.calendarListResults.innerHTML = '';
        if(this.eventData.events.length) {
            this.eventData.events.forEach( event => {
                this.templateEvents(event);      
            })
        } else {
            this.noResults.style.display= 'inline';
        }
        this.addLoadMoreListeners();
        
    }

    getAPIString() {
        let string = this.calendar.getAttribute('data-json');
        string = string + '&timeframe=' + this.timeframe + '&s=' + this.search;

        // const allFilters = Array.from(this.calendar.querySelectorAll('.calendar-map__sidebar-filter-box-buttons button[data-filter]')).map( filter => filter.dataset.filter);

        // if(this.tags.length){
        //     this.tags.forEach(tag => {
        //         // remove filter from all filters
        //         const index = allFilters.indexOf(tag);
        //         if (index > -1) {
        //             allFilters.splice(index, 1);
        //         }
        //     });
        // }

        if(this.tags.length) {
            this.tags.forEach(filter => {
                string = string + "&event-tag[]=" + filter;
            });
        }

        if(this.pastCalendar){
            string = string + "&past=" + this.pastCalendar;
        } 

        return string;
    }

    templateEvents(event) {
        let template = _.template(this.eventTemplate.innerHTML);
        let compiledResult = template(event);
        this.calendarListResults.insertAdjacentHTML( 'beforeend', compiledResult );
    }

    loadMap() {
        const mapElement = document.getElementById('map');

        window.initMap = async () => {
            await this.initMap(mapElement);
        }

        // load google maps api
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${mapElement.getAttribute('data-api-key')}&callback=initMap`;
        script.defer = true;
        script.async = true;
        document.head.appendChild(script);
    }

    async updateMap() {

        if(this.markerArray.length) {
            this.markerArray.forEach(m => {
                m.setMap(null);
            });
            this.markerArray = [];
        }

        const sideBarClose = this.calendar.querySelector('.calendar-map__close');
        const sideBar = this.calendar.querySelector('.calendar-map__sidebar');
        const sideBarImage = sideBar.querySelector('.calendar-map__sidebar-event-image');
        const sideBarTitle = sideBar.querySelector('.calendar-map__sidebar-event-details-title');
        const sideBarWhen = sideBar.querySelector('.calendar-map__sidebar-event-details-when .calendar-map__stat-row p');
        const sideBarLocation = sideBar.querySelector('.calendar-map__sidebar-event-details-location .calendar-map__stat-row p');
        const sideBarLocationDesc = sideBar.querySelector('.calendar-map__sidebar-event-details-location .calendar-map__stat-desc');
        const sideBarAbout = sideBar.querySelector('.calendar-map__sidebar-event-details-about p');
        const sideBarCta = sideBar.querySelector('.calendar-map__learn-more-cta');
        const filterButtonsContainer = this.calendar.querySelector('.calendar-map__sidebar-filter-box-buttons');

        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

        sideBarClose.addEventListener('click', () => {
            sideBar.classList.remove('calendar-map__sidebar--fade-in');
            setTimeout(() => {
                sideBar.classList.remove('calendar-map__sidebar--show');
            }, 10);
        })

        
        this.eventData.events.filter(i => i.map && i.image).forEach(event => {
            if(event['has_map']) {
                const pin = new PinElement({
                    background: event['eventTags'] && event['eventTags'].length ? event['eventTags'][0].colour : "#fe5000",
                    borderColor: 'white',
                    glyphColor: 'white'
                });

                const marker = new AdvancedMarkerElement({
                    position: {
                        lat: event.map.lat,
                        lng: event.map.lng
                    },
                    map: this.map,
                    title: event.title,
                    content: pin.element
                });

                marker.addListener('click', () => {
                    sideBarImage.setAttribute('src', event.image.url);
                    sideBarTitle.innerHTML = event.title ?? '';
                    sideBarLocation.textContent = event.map.address ?? '';
                    sideBarLocationDesc.textContent = event.location ?? '';
                    sideBarAbout.textContent = event.excerpt ?? '';
                
                    let whenString = event.date;
                    if(event.end_date) {
                        whenString += ` - ${event.end_date}`
                    }
                    if(event.time) {
                        whenString += ` • ${event.time}`;
                        if(event.end_time) {
                            whenString += ` - ${event.end_time}`;
                        }
                    }
                    sideBarWhen.textContent = whenString;
                    
                    if(event.has_page) {
                        sideBarCta.setAttribute('href', event.link);
                        sideBarCta.style.display = 'inline-block';
                    } else {
                        sideBarCta.setAttribute('href', '#');
                        sideBarCta.style.display = 'none';
                    }

                    sideBar.classList.add('calendar-map__sidebar--fade-in');

                    setTimeout(() => {
                        sideBar.classList.add('calendar-map__sidebar--show');
                    }, 0);

                    // center map on pin
                    this.map.panTo(marker.position);
                });

                this.markerArray.push(marker);
                event.marker = marker;
            }
        });
    }

    async initMap(mapElement) {

        // Specify the initial coordinates (latitude and longitude)
        const centerPoint = { lat: 32.6388086, lng: -117.0842 };
        // Create a new map centered at the specified coordinates
        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 11,   // Set the initial zoom level
            center: centerPoint,  // Set the initial center of the map
            mapId: mapElement.getAttribute('data-map-id')   // Set the Map ID
        });

        await this.loadEvents();
        this.updateMap()

    }

    debounce(func, delay) {
        let timeoutId;
    
        return function () {
          const context = this;
          const args = arguments;
    
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(context, args);
          }, delay);
        };
      }

}